/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useCallback, useEffect } from "react"
import { observer } from "mobx-react-lite"
import { TextStyle, View, ViewStyle, ImageStyle, Platform, Appearance, Alert } from "react-native"
import { AutoImage, Button, Screen, Text } from "../../../components"
import { useStores } from "../../../models"
import { color, images } from "../../../theme"
import { AppStackInitialSync, navigate, resetRoot } from "../../../navigators"
import { useFocusEffect } from "@react-navigation/native"
import { translate } from "../../../i18n"
import JalaAnalytic from "../../../utils/jala-analytic"

const isIos = Platform.OS === 'ios';

// const jala = require("./jala.png")

const ROOT: ViewStyle = {
  flexGrow: 1,
  paddingHorizontal: 16
}

const IMAGE_CONTAINER: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
}

const JALA_LOGO: ImageStyle = {
  height: 84,
  // width:130,
  resizeMode: 'contain'
}

const LOGO_TEXT: TextStyle = {
  fontFamily: 'Lato',
  fontSize: 16,
  color: 'white',
  textAlign: 'center'
}

const LINE_BAR_TEXT: TextStyle = {
  marginHorizontal: 10
}

const BORDER_LINE: ViewStyle = {
  height: 1,
  flex: 1,
  backgroundColor: color.line
}

const BORDER_CONTAINER: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  marginVertical: 12
}

const IMG_LOGO: ImageStyle = {
  height: 25,
  resizeMode: 'contain',
}

const LOGIN_BUTTON: ViewStyle = {
  marginTop: 16,
  flexDirection: 'row'
}

const LOGIN_EMAIL_BUTTON: ViewStyle = {
  marginBottom: 32,
}

export const SocialLoginScreen: FC<{ colorScheme?: "light" | "dark" }> = observer(function SocialLoginScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props

  const {
    loginStore, loginStore: { error: loginError, notRegisteredUser, socialLoginEnabled },
    tokenStore, tokenStore: { token, error: tokenError }
  } = useStores()

  const { apple, facebook, google } = socialLoginEnabled || {}

  useEffect(() => {
    tokenStore.setLoading(false)
    tokenStore.setError(null)
  }, [tokenStore])

  useEffect(() => {
    if (token) resetRoot(AppStackInitialSync)
  }, [token])

  useFocusEffect(useCallback(() => {
    if (loginError)
      Alert.alert(
        translate('AlertFailedTitle'),
        translate('AlertUserUnauthenticated'),
        [ { onPress: () => loginStore.set('error', null) } ]
      );
    return () => loginStore.set('error', null);
  }, [loginError, loginStore]))

  useFocusEffect(useCallback(() => {
    if (tokenError) {
      Alert.alert(
        translate('AlertFailedTitle'),
        translate('AlertUserUnauthenticated'),
        [ { onPress: () => tokenStore.setError(null) } ]
      );
    }
    return () => tokenStore.setError(null);
  }, [tokenError, tokenStore]))

  useEffect(() => {
    if (notRegisteredUser) {
      JalaAnalytic.log('Mobile App: Login Social Media - Not Found User ')
      navigate('Login.Stack', 'Login.Register', {...notRegisteredUser})
    }
  }, [notRegisteredUser])

  return (
    <Screen
      style={ROOT} preset="scroll"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.primary : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
      hideNavigationBar={true}
    >
      <View style={IMAGE_CONTAINER}>
        <AutoImage source={images.logo_white} resizeMode="contain" style={JALA_LOGO} />
        <Text tx="socialLoginScreen.socialLoginScreenTitle" preset="body1" colorScheme="dark" style={LOGO_TEXT} />
      </View>
      {isIos && (apple !== false) && (
        <Button testID="jala:id/login-apple-button" preset="primary" colorScheme="dark" style={LOGIN_BUTTON} onPress={loginStore.appleSignIn}>
         <AutoImage source={images.appleLogo} style={IMG_LOGO} />
         <Text tx="socialLoginScreen.loginWithApple" preset="title4" colorScheme="light" />
        </Button>
      )}
      {(google !== false) && <Button testID="jala:id/login-google-button" preset="primary" colorScheme="dark" style={LOGIN_BUTTON} onPress={loginStore.googleSignIn}>
        <AutoImage source={images.googleLogo} style={IMG_LOGO} />
        <Text tx="socialLoginScreen.loginWithGoogle" preset="title4" colorScheme="light" />
      </Button>}
      {(facebook !== false) && <Button testID="jala:id/login-facebook-button" preset="primary" colorScheme="dark" style={LOGIN_BUTTON} onPress={loginStore.facebookSignIn}>
        <AutoImage source={images.facebookLogo} style={IMG_LOGO} />
        <Text tx="socialLoginScreen.loginWithFacebook" preset="title4" colorScheme="light" />
      </Button>}
      <View style={BORDER_CONTAINER}>
        <View style={BORDER_LINE} />
        <Text tx="socialLoginScreen.or" preset="body3" color={color.palette.white} style={LINE_BAR_TEXT}/>
        <View style={BORDER_LINE} />
      </View>
      <Button
        testID="jala:id/login-email-button"
        tx="socialLoginScreen.loginWithPhoneEmail"
        preset="primary"
        colorScheme="dark"
        textColor={colorScheme === "light" ? color.primary : undefined}
        style={LOGIN_EMAIL_BUTTON}
        onPress={() => navigate('Login.Stack', 'Login.Login')}
        isTruncated={true}
      />
    </Screen>
  )
})
